<template>
  <tr
    :class="{
      attention: !item.isSuggestEnable
    }"
  >
    <td>
      <EllipsisTip>
        {{ item.keyword }}
      </EllipsisTip>
    </td>
    <td>
      <ul class="flex" v-if="item.startDate">
        <li>
          {{ item.startDate | dateText('YYYY.MM.DD') }}
        </li>
        <li>
          <template v-if="item.isSuggestEnable">
            <div class="c-alertPos">
              <Alert v-if="updateAnalysisResponse" style="right:-16px;">
                {{ updateAnalysisResponse }}
              </Alert>
              <Button
                variant="reload"
                :disabled="isReloading || disabledReload"
                @click="reloadItem"
              >
                更新
              </Button>
            </div>
          </template>
          <template v-else>
            <span class="noData">-</span>
          </template>
        </li>
      </ul>
      <template v-else>
        <p class="c-text--center">-</p>
      </template>
    </td>
    <td>
      <div class="flexWrap">
        <div class="block-state">
          <ul
            class="flex"
            :class="{
              'is-getable': !item.isSuggestGetable,
              'is-enable': !item.isSuggestEnable
            }"
          >
            <li class="check">
              <Icon2 variant="check" size="14" />
              {{ item.isSuggestGetable ? '取得済' : '未取得' }}
            </li>
            <li class="c-alertPos">
              <Alert v-if="errorResponse">{{ errorResponse }}</Alert>
              <Button
                v-if="item.isSuggestEnable"
                :to="{
                  name: 'competitiveKeywordSuggestAnalysis',
                  params: { keywordId: item.id },
                  query: {
                    keyword: item.keyword,
                    startDate: $options.filters.dateText(
                      item.startDate,
                      'YYYY-MM-DD'
                    )
                  }
                }"
                fsize="f13"
                icon="arrow_r"
                variant="main"
                class="l-w-180"
              >
                関連ワード分析
              </Button>
              <Button
                v-else
                fsize="f13"
                icon="arrow_r"
                variant="main"
                class="l-w-180"
                :disabled="isStartingSuggest"
                @click="startSuggest"
              >
                関連ワード分析を開始
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </td>
    <td class="c-text--center">
      <Button variant="delete" :disabled="isDeleting" @click="deleteItem">
        削除
      </Button>
    </td>
  </tr>
</template>

<script>
import { USAGE_LABEL } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import EllipsisTip from '@/components/EllipsisTip';
import Icon2 from '@/components/Icon2';
import apiProjects from '@/api/projects';

export default {
  props: ['item', 'project'],

  components: {
    Alert,
    Button,
    EllipsisTip,
    Icon2
  },

  data() {
    return {
      errorResponse: '',
      updateAnalysisResponse: '',
      isDeleting: false,
      isReloading: false,
      isStartingSuggest: false
    };
  },

  computed: {
    disabledReload() {
      if (!this.item.isSuggestGetable && !this.item.isCompetitorRankGetable) {
        return true;
      } else {
        if (
          !this.item.isCompetitorRankGetable &&
          this.item.isCompetitorRankEnable
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  },

  methods: {
    deleteItem() {
      if (this.isDeleting) {
        return;
      }
      this.isDeleting = true;

      let params = {
        keywordId: this.item.id,
        url: this.project.siteUrl,
        startDate: this.$options.filters.dateText(this.item.startDate)
      };

      apiProjects.researchKeywords
        .delete(params, this.auth.idToken, this.project.id)
        .then(response => {
          this.$emit('delete', this.item);
        })
        .catch(error => {
          this.isDeleting = false;
        });
    },

    reloadItem() {
      if (this.isReloading) {
        return;
      }

      this.isReloading = true;

      this.getUsages()
        .then(response => {
          let current = response.data.items[0].current;
          let max = response.data.items[0].max;
          if (current >= max) {
            this.updateAnalysisResponse = `月間に登録できる上限数を超えています`;
            this.isReloading = false;
            // 使用量で引っかかっている場合でも分析の使用量を更新します
            // 複数のユーザーが同時に操作をした場合に現在の使用量の数が違う場合があるため
            this.$emit('reloadUsage');
            return;
          }
          // 利用量の上限を超えていない時だけ再分析を開始する
          let params = {
            keywordId: this.item.id
          };

          apiProjects.keywordAnalyses.update
            .post(params, this.auth.idToken, this.project.id)
            .then(response => {
              this.$emit('reload', this.item);
              // 分析数の使用量を更新します
              this.$emit('reloadUsage');
              if (
                this.item.isSuggestGetable &&
                this.item.isCompetitorRankGetable
              ) {
                this.isReloading = false;
              }
            })
            .catch(error => {
              this.isReloading = false;
            });
        })
        .catch(error => {
          if (error.response) {
            this.updateAnalysisResponse =
              error.response.data.errors[0].userMessage;
          }
          this.isReloading = false;
        });
    },

    goSuggest(startDate) {
      this.$router.push({
        name: 'competitiveKeywordSuggestAnalysis',
        params: { keywordId: this.item.id },
        query: {
          keyword: this.item.keyword,
          startDate: this.$options.filters.dateText(startDate, 'YYYY-MM-DD')
        }
      });
    },

    getUsages() {
      const params = {
        items: 'competitor-analyses'
      };
      return apiProjects.usages.get(params, this.auth.idToken, this.project.id);
    },

    startSuggest() {
      if (this.isStartingSuggest) {
        return;
      }
      this.isStartingSuggest = true;

      // 利用量を取得
      this.getUsages()
        .then(response => {
          let current = response.data.items[0].current;
          let max = response.data.items[0].max;
          if (current >= max) {
            this.errorResponse = `月間に登録できる上限数を超えています`;
            this.isStartingSuggest = false;
            return;
          }
          // 利用量の上限を超えていない時だけキーワード分析を開始する
          let params = {
            projectId: this.project.id, //消したい
            keywordId: this.item.id
          };
          apiProjects.suggestAnalyses
            .post(params, this.auth.idToken, this.project.id)
            .then(response => {
              this.goSuggest(response.data.startDate);
            })
            .catch(error => {
              if (error.response) {
                this.errorResponse = error.response.data.errors[0].userMessage;
              }
              this.isStartingSuggest = false;
            });
        })
        .catch(error => {
          if (error.response) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          }
          this.isStartingSuggest = false;
        });
    }
  }
};
</script>
